import React from 'react';
import { View, Text, Platform } from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import { Utils } from './Utils';
import PressableStyled from '../components/PressableStyled';
import Colors from '../constants/Colors';
import Style from '../constants/Style';
import isMobile from '../components/IsMobile';

export default function HeaderControls(props) {
  const {
    styles,
    currentMonth,
    currentYear,
    onPressNext,
    onPressPrevious,
    onPressYear,
    months,
    titleStyle,
    textStyle,
    restrictMonthNavigation,
    maxDate,
    minDate,
    headingLevel,
    monthYearHeaderWrapperStyle,
    headerWrapperStyle,
    headerButtonStyle,
  } = props;
  const MONTHS = months || Utils.MONTHS; // English Month Array
  const monthName = MONTHS[currentMonth];
  const year = currentYear;

  const disablePreviousMonth: boolean = restrictMonthNavigation
    && Utils.isSameMonthAndYear(minDate, currentMonth, currentYear);
  const disableNextMonth: boolean = restrictMonthNavigation
    && Utils.isSameMonthAndYear(maxDate, currentMonth, currentYear);

  const accessibilityProps = { accessibilityRole: 'header' };
  if (Platform.OS === 'web') {
    accessibilityProps['aria-level'] = headingLevel;
  }

  return <View style={[styles.headerWrapper, headerWrapperStyle]}>
    <PressableStyled
      style={[styles.monthYearHeaderWrapper, monthYearHeaderWrapperStyle]}
      onPress={onPressYear}
      testID='select-year-btn'
    >
      <Text style={[styles.monthHeaderMainText, textStyle, titleStyle]}>
        {`${monthName} ${year}`}
      </Text>
      {!isMobile && <FontAwesome
        color={Colors.light.hereworksBlue500}
        size={24}
        name='angle-down'
      />}
    </PressableStyled>
    <View style={Style.row}>
      <PressableStyled
        disabled={disablePreviousMonth}
        onPress={onPressPrevious}
        style={{ marginEnd: 12 }}
        testID='previous-month-btn'
      >
        <FontAwesome
          style={headerButtonStyle}
          size={24}
          name='angle-left'
        />
      </PressableStyled>
      <PressableStyled
        disabled={disableNextMonth}
        onPress={onPressNext}
        style={{ marginStart: 12 }}
        testID='next-month-btn'
      >
        <FontAwesome
          style={headerButtonStyle}
          size={24}
          name='angle-right'
        />
      </PressableStyled>
    </View>
  </View>;
}
